export const SET_LOGINED = 'SET_LOGINED'

export const REMOVE_LOGINED = 'REMOVE_LOGINED'

export const SET_USER = 'SET_USER'

export const ADD_READED_MESSAGE = 'ADD_READED_MESSAGE'

export const REMOVE_UNREAD_MESSAGE = 'REMOVE_UNREAD_MESSAGE'

export const ADD_UNREAD_MESSAGE = 'ADD_UNREAD_MESSAGE'

export const SET_USER_AUTHS = 'SET_USER_AUTHS'

export const SET_REFERSH_OPTION = 'SET_REFERSH_OPTION'

export const SET_PROJECT = "SET_PROJECT"

export const SET_FEATURES = "SET_FEATURES"
